import React from 'react'

export default function GoogleMap() {
  return (
    <section className="relative w-full bg-stone-100 py-12 border-t border-stone-200">
      <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="relative overflow-hidden rounded-2xl border border-stone-300 bg-white p-2 shadow-sm">
          <div className="absolute top-4 left-4 z-10 rounded-xl bg-neutral-950/95 backdrop-blur-md border border-neutral-800 p-5 shadow-2xl max-w-xs">
            <h4 className="font-display text-sm font-semibold text-[#DFB587] uppercase tracking-wider">
              Besøg os
            </h4>
            <p className="mt-1.5 text-xs text-stone-200">
              Industrivej 52, 7080 Børkop
            </p>
            <p className="mt-2 text-[11px] text-stone-400">
              Vi ligger centralt placeret nær Vejle, Kolding og Fredericia.
            </p>
            <a
              href="https://www.google.com/maps/place/Industrivej%2052,%207080%20B%C3%B8rkop"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3.5 inline-flex items-center gap-1.5 text-xs font-semibold text-[#DFB587] hover:text-white transition-colors"
            >
              Få rutevejledning <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
            </a>
          </div>
          
          <div className="relative h-[400px] w-full overflow-hidden rounded-xl">
            <iframe
              title="Recars ApS Beliggenhed"
              src="https://maps.google.com/maps?q=Industrivej%2052,%207080%20B%C3%B8rkop&t=&z=14&ie=UTF8&iwloc=&output=embed"
              className="absolute inset-0 h-full w-full border-0 transition-all duration-300"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
